import React, { useEffect, useState } from 'react'
import { Row, Col, Card, Divider, Select, Input, Progress, Upload, Button, Modal, Form, DatePicker, Avatar, Alert, message } from 'antd';
import { FaMapMarkerAlt, FaGlobe, FaCity, FaMapPin, FaRegEnvelope, FaRegUser, FaPhone, FaCheckCircle } from "react-icons/fa";
import { fetchProfileImageUpdate, getProfileCreateUser, getProfileDetails } from '../services/auth/authServices';
import moment from 'moment';
import { done, profile_banner } from '../utils/ImagePath';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { getotpConfirmationEmail, mailVerifyFunction } from '../services/flight/flightServices';
import { setModal2Open } from '../redux/hotel/modalSlice';
import { useDispatch } from 'react-redux';

const Profile = () => {

    let profile_pic = JSON.parse(localStorage.getItem('profile_pic'));

    const fieldsToCheck = [
        'profile_pic', 'firstName', 'lastName', 'phone_no', 'email', 'gender', 'dob',  // Profile Info
        'billing_address', 'pincode', 'city', 'country'                 // Billing Info
    ];
    const [completionPercentage, setCompletionPercentage] = useState(0);
    const [profile, setProfile] = useState(0);
    const [successMessage, setSuccessMessage] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [formBilling] = Form.useForm();
    const { Option } = Select;
    const [profileData, setProfileData] = useState('');
    const [email, setEmail] = useState(profileData?.email);

    useEffect(() => {
        if (profileData?.email) {
            setEmail(profileData.email);
        }
    }, [profileData]);

    const [triggerEffect, setTriggerEffect] = useState(false);
    const [statusMessageVerify, setStatusMessageVerify] = useState('')
    const [selectDate, setSelectDate] = useState(profileData?.dob);

    const handleChange = (date, dateString) => {
        setSelectDate(dateString);
    };

    const disabledDate = (current) => {
        return current && current > moment().endOf('day');
    };


    const handleUpload = async ({ fileList: newFileList }) => {
        setFileList(newFileList);
        if (newFileList.length === 0) {
            message.error('Please select a file to upload');
            return;
        }
        const formData = new FormData();
        formData.append('profile_pic', newFileList[0].originFileObj);
        setLoading(true);
        try {
            const response = await fetchProfileImageUpdate(formData);
            if (response.status === 201) {
                setFileList([]);
                localStorage.setItem("profile_pic", JSON.stringify(response.data.fileUrl));
            }
        } catch (error) {
            console.log("error", error)
        } finally {
            setLoading(false);
        } setProfileData
    };

    const [messageApi, contextHolder] = message.useMessage();

    const info = () => {
        messageApi.success('Profile Updated Successfully ');
    };

    const onFinish = (values) => {
        if (!(profileData?.is_email_verified === true || profileData?.is_email_verified === 1)) {
            return;
        }
        setLoading(true);
        let reqBody = {
            firstName: values?.firstName,
            lastName: values?.lastName,
            email: values?.email || email,
            phone_no: values?.phone_no,
            dob: selectDate ? selectDate : profileData?.dob,
            gender: values.gender,
        };
        getProfileCreateUser(reqBody)
            .then((response) => {
                setLoading(false);
                setProfile(!profile)
                setSuccessMessage(true);
                localStorage.setItem("user", JSON.stringify(response?.data?.data?.user));
                localStorage.setItem("profile_pic", JSON.stringify(response?.data?.data?.user.profile_pic));
                localStorage.setItem("isProfile", JSON.stringify(true));
                setTimeout(() => {
                    setSuccessMessage(false);
                }, 2000);
                navigate(location.pathname, { replace: true });
                info();
            })
            .catch((error) => {
                setLoading(false);
                console.log("error", error)
            });
    };

    const onFinishBilingAdress = (values) => {
        setLoading(true);
        let reqBody = {
            billing_address: values?.address,
            pincode: values?.pincode,
            state: values?.state,
            city: values?.city,
            country: values?.Country,
        };
        getProfileCreateUser(reqBody)
            .then((response) => {
                setProfile(!profile)
                info();
            })
            .catch((error) => {
                setLoading(false);
                console.log("error", error)
            });
    };

    useEffect(() => {
        // This will run whenever the URL path changes to '/profile'
        if (location.pathname === '/create-profile') {
            fetchProfileData();
        }
    }, [location.pathname]);

    // useEffect(() => {
    //     setLoading(true);
    //     getProfileDetails()
    //         .then((resp) => {
    //             // Populate the form with fetched profile details
    //             form.setFieldsValue({
    //                 firstName: resp.firstName,
    //                 lastName: resp.lastName,
    //                 email: email,
    //                 phone_no: resp.phone_no,
    //                 gender: resp.gender,
    //                 dob: resp.dob ? dayjs(resp.dob, "YYYY-MM-DD") : null,
    //             });

    //             // Additional billing form data
    //             formBilling.setFieldsValue({
    //                 address: resp.billing_address,
    //                 pincode: resp.pincode,
    //                 state: resp.state,
    //                 city: resp.city,
    //                 Country: resp.country,
    //             });


    //             setProfileData(resp);
    //             setLoading(false);
    //         })
    //         .catch((err) => {
    //             console.log("Error fetching profile:", err);
    //             setLoading(false);
    //         });
    // }, [profile, triggerEffect]);


    const fetchProfileData = async () => {
        setLoading(true);
        try {
            const resp = await getProfileDetails();

            form.setFieldsValue({
                firstName: resp.firstName,
                lastName: resp.lastName,
                email: resp.email,
                phone_no: resp.phone_no,
                gender: resp.gender,
                dob: resp.dob ? dayjs(resp.dob, "YYYY-MM-DD") : null,
            });

            formBilling.setFieldsValue({
                address: resp.billing_address,
                pincode: resp.pincode,
                state: resp.state,
                city: resp.city,
                Country: resp.country,
            });

            setProfileData(resp);
            setEmail(resp.email);
        } catch (err) {
            console.log("Error fetching profile:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        calculateCompletionPercentage();
    }, [profileData]);

    const calculateCompletionPercentage = () => {
        let percentage = 0;
        if (profileData['profile_pic'] && profileData['profile_pic'] !== '') {
            percentage += 20;
        }
        let filledFields = 0;
        const remainingFields = fieldsToCheck.filter(field => field !== 'profile_pic');
        remainingFields.forEach((field) => {
            if (profileData[field] && profileData[field] !== '') {
                filledFields++;
            }
        });
        // Calculate percentage for the remaining fields
        const remainingPercentage = Math.round((filledFields / remainingFields.length) * 80);
        percentage += remainingPercentage;
        setCompletionPercentage(percentage);
    };

    const [otp, setOtp] = useState("");

    const [emailVerifyModal, setEmailVerifyModal] = useState(false);

    const [verifiedStatus, setVerifiedStatus] = useState(
        JSON.parse(localStorage.getItem("verifiedStatus")) || false
    );


    const [statusMessage, setStatusMessage] = useState("");
    const [invalidMessage, setInvalidMessage] = useState("");

    const [formOtpVerify] = Form.useForm();


    const fetchMailVerify = async () => {
        setLoading(true);
        const payload = { email };
        try {
            await mailVerifyFunction(payload);
            setEmailVerifyModal(true);


        } catch (error) {
            setStatusMessageVerify(error?.response?.data?.message)
            setTimeout(() => {
                setStatusMessageVerify("");
            }, 2000);
            console.error("Verification Email Failed:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleFinishMailVerify = async () => {
        try {
            const payload = { email, otp };
            const response = await getotpConfirmationEmail(payload);
            setTriggerEffect(true);
            window.location.reload()
            if (response?.data?.message === "Invalid OTP.") {
                setInvalidMessage(response.data?.message);
                setStatusMessage(response?.data?.message)
                setStatusMessageVerify("");
                setTimeout(() => {
                    setEmailVerifyModal(false);
                }, 2000);

                setTimeout(() => setInvalidMessage(""), 2000);
            } else {
                setVerifiedStatus(true);
                localStorage.setItem("verifiedStatus", JSON.stringify(true));
                setEmailVerifyModal(false);
                setStatusMessage(response?.data?.message || "Email Verified Successfully");
            }
        } catch (error) {
            setInvalidMessage(
                error.response?.data?.message || "An error occurred while verifying OTP."
            );
            console.error("OTP Verification Failed:", error);
        }
    };


    let isUserType = JSON.parse(localStorage.getItem('isUserType'));
    const dispatch = useDispatch();
    const openModal = () => {
        dispatch(setModal2Open(true));
    };

    return (
        <>
            {contextHolder}

            <section className='Edit-Profile create-profile mb-5'>
                <div className='bg-primary position-relative' style={{ height: "160px", marginBottom: "-60px" }}>
                    <img loading="lazy" src={profile_banner} alt='#' className='w-100 position-absolute' height={160} style={{ objectFit: "cover" }} />
                    <div className='w-100' style={{ background: "radial-gradient(transparent, #214a93)", height: "160px", position: "absolute" }}></div>
                    <div className='container'>
                        <Row gutter={16}>
                            <Col md={12}>
                                <h2 className='text-white pt-4'>Profile</h2>
                            </Col>
                            <Col md={12}></Col>
                        </Row>
                    </div>
                </div>

                <div className='container'>
                    <Row gutter={16}>
                        <Col md={3}></Col>
                        <Col md={18}>


                            {!isUserType ?
                                <Card className="mb-3">

                                    <div className='card-header'>
                                        <h2> Welcome, Traveller!</h2>
                                    </div>
                                    <Divider className="my-2 mb-3" />
                                    <p> 🎉 You’ve Unlocked Super Coins!</p>
                                    <p>  Thanks for booking your recent flight with Superb World Trip!
                                        To instantly claim your reward, please log in and complete your profile — it takes less than a minute!
                                        👉 First, log in
                                        👉 Then, create your profile
                                        Start earning and enjoying your Super Coins today!
                                    </p><br />
                                    <Button onClick={openModal} className="btn btn-primary menu-block" aria-label="login register">
                                        <span className='lh-sm'>Login/Register</span>
                                    </Button>

                                </Card>

                                :
                                <>
                                    <Card className="mb-3">
                                        <div className='d-flex gap-3'>
                                            <div className="profile-picture-upload">
                                                <div className=''>
                                                    <Avatar
                                                        src={profile_pic || 'https://via.placeholder.com/150'}
                                                        alt="Profile Picture"
                                                        className="profile-avatar"
                                                        size={120}
                                                        style={{ border: "2px solid #1890ff" }} // Custom border
                                                    />
                                                    <br />
                                                    <Upload
                                                        listType=""
                                                        fileList={fileList}
                                                        onChange={handleUpload}
                                                        // onPreview={handlePreview}
                                                        beforeUpload={() => false}
                                                        showUploadList={false}
                                                    >
                                                        <Button className="upload-button border-0 p-0 mt-0" aria-label="edit profile">
                                                            {!profileData?.profile_pic ? "Edit Profile Photo" : "Edit Profile Photo"}
                                                        </Button>
                                                    </Upload>
                                                </div>
                                            </div>

                                            <div className='w-100'>
                                                <div className='' style={{ height: '110px' }}>
                                                    <h2 className='mb-1 lh-sm'>
                                                        {profileData?.firstName && profileData?.lastName
                                                            ? `${profileData.firstName} ${profileData.lastName}`
                                                            : "Traveller"}
                                                    </h2>
                                                    <p className='lh-sm'>{profileData?.phone_no
                                                        ? `${profileData.phone_no}`
                                                        : "0000000000"}    </p>
                                                    <p className='lh-sm'> {profileData?.email
                                                        ? `${profileData.email}`
                                                        : "example@gmail.com"} </p>
                                                </div>
                                                <Progress percent={completionPercentage} status="active" />
                                                <small>{completionPercentage}% Profile Completed</small>
                                            </div>
                                        </div>

                                    </Card>
                                    <Card className="mb-3">
                                        <div className='card-header'>
                                            <h2>Profile</h2>
                                        </div>
                                        <Divider className="my-2 mb-3" />
                                        {successMessage &&
                                            <Alert message="Congratulations your profile update" className='mb-4' type="success" showIcon />
                                        }
                                        <Form
                                            form={form}
                                            onFinish={onFinish}

                                            layout="vertical"
                                        >
                                            <Row gutter={16}>
                                                <Col md={12} className='w-100'>
                                                    <Form.Item
                                                        name="firstName"
                                                        label="Enter Your firstName"
                                                        className="mb-3 pulse_input"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: "First name is required",
                                                            },
                                                        ]}
                                                    >
                                                        <Input
                                                            className='from-control'
                                                            placeholder='Enter your first name'
                                                            prefix={<FaRegUser className="me-2" />}
                                                        />
                                                    </Form.Item>
                                                </Col>

                                                <Col md={12} className='w-100'>
                                                    <Form.Item
                                                        name="lastName"
                                                        label="Enter Your lastName"
                                                        className="mb-3 pulse_input"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: "Last name is required",
                                                            },
                                                        ]}
                                                    >
                                                        <Input
                                                            className='from-control'
                                                            placeholder='Enter your last name'
                                                            prefix={<FaRegUser className="me-2" />}
                                                        />
                                                    </Form.Item>
                                                </Col>

                                                <Col md={12} className='w-100'>
                                                    <Form.Item
                                                        name="phone_no"
                                                        label="Your Contact Number"
                                                        className="mb-3 pulse_input"
                                                    >
                                                        <Input
                                                            readOnly
                                                            className='from-control'
                                                            prefix={<span> <FaPhone className="me-2" /></span>}
                                                            suffix={<span style={{ color: "#52c41a" }}><FaCheckCircle twoToneColor="#52c41a" /> verified </span>}
                                                        />
                                                    </Form.Item>
                                                </Col>

                                                <Col md={12} className="w-100">
                                                    <Form.Item
                                                        name="email"
                                                        label="Enter your Email"
                                                        className="mb-3 pulse_input"
                                                        rules={[
                                                            {
                                                                required: !(profileData?.is_email_verified === true || profileData?.is_email_verified === 1),
                                                                message: "Email is required",
                                                            },
                                                            {
                                                                type: "email",
                                                                message: "Please enter a valid email address"
                                                            },
                                                            ...(!(profileData?.is_email_verified === true || profileData?.is_email_verified === 1)
                                                                ? [
                                                                    {
                                                                        validator: (_, value) => {
                                                                            if (value && !(profileData?.is_email_verified === true || profileData?.is_email_verified === 1)) {
                                                                                return Promise.reject("Please verify your email.");
                                                                            }
                                                                            return Promise.resolve();
                                                                        }
                                                                    }
                                                                ]
                                                                : [])
                                                        ]}

                                                    >
                                                        <Input
                                                            placeholder="Enter your email"
                                                            prefix={<FaRegEnvelope className="me-2" />}
                                                            value={email}
                                                            className="from-control"
                                                            readOnly={profileData?.is_email_verified === 1 || profileData?.is_email_verified === true}
                                                            onChange={(e) => {
                                                                form.setFieldsValue({ email: e.target.value });
                                                                setEmail(e.target.value);
                                                            }}
                                                            suffix={
                                                                <span>
                                                                    {profileData?.is_email_verified === 1 || profileData?.is_email_verified === true ? (
                                                                        <span style={{ color: "#52c41a" }}>
                                                                            <FaCheckCircle twoToneColor="#52c41a" /> Verified
                                                                        </span>
                                                                    ) : (
                                                                        <Button type="link" onClick={fetchMailVerify} loading={loading} aria-label="verify">
                                                                            Verify
                                                                        </Button>
                                                                    )}
                                                                </span>
                                                            }
                                                        />
                                                        <span style={{ color: "#ff4d4f" }}>
                                                            {statusMessageVerify}
                                                        </span>
                                                    </Form.Item>
                                                </Col>


                                                <Col md={12} className='w-100'>
                                                    <Form.Item
                                                        name="gender"
                                                        label="Gender"

                                                    >
                                                        <Select
                                                            placeholder="Please select your gender"
                                                            allowClear
                                                            className='from-control'

                                                        >
                                                            <Option value="male">Male</Option>
                                                            <Option value="female">Female</Option>
                                                            <Option value="other">Other</Option>
                                                        </Select>
                                                    </Form.Item>
                                                </Col>

                                                <Col md={12} className='w-100'>
                                                    <Form.Item
                                                        name="dob"
                                                        label="Date of Birth"
                                                    >
                                                        <div className="form-group mb-2">
                                                            <DatePicker
                                                                showNow={false}
                                                                format="YYYY-MM-DD"
                                                                placeholder="Select Date of Birth"
                                                                disabledDate={disabledDate}
                                                                className='from-control w-100'
                                                                value={
                                                                    selectDate
                                                                        ? dayjs(selectDate)
                                                                        : profileData?.dob
                                                                            ? dayjs(profileData.dob)
                                                                            : null
                                                                }
                                                                onChange={handleChange}
                                                            />

                                                        </div>
                                                    </Form.Item>
                                                </Col>


                                                <Col md={24} className="text-center mt-4">
                                                    <Button htmlType='submit' className='btn btn-primary' aria-label="submit">Submit</Button>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </Card>
                                    <Card>
                                        <div className='card-header'>
                                            <h2>Billing Information</h2>
                                        </div>
                                        <Divider className="my-2 mb-3" />

                                        <Form
                                            form={formBilling}
                                            onFinish={onFinishBilingAdress}
                                            layout="vertical"
                                        >
                                            <Row gutter={16}>
                                                <Col md={24} className='w-100'>
                                                    <Form.Item
                                                        name="address"
                                                        label="Address"
                                                        className="mb-3 pulse_input"

                                                    >
                                                        <Input className='from-control rounded' placeholder="Enter your address" prefix={<FaMapMarkerAlt />} />
                                                    </Form.Item>
                                                </Col>

                                                <Col md={8} className='w-100'>
                                                    <Form.Item
                                                        name="pincode"
                                                        label="Enter Your Pincode"
                                                        className="mb-3 pulse_input"

                                                    >
                                                        <Input className='from-control rounded' placeholder="pincode" prefix={<FaMapPin />} />
                                                    </Form.Item>
                                                </Col>

                                                <Col md={8} className='w-100'>
                                                    <Form.Item
                                                        name="city"
                                                        label="City"
                                                        className="mb-3 pulse_input"

                                                    >
                                                        <Input className='from-control rounded' placeholder="Enter your city" prefix={<FaCity />} />
                                                    </Form.Item>
                                                </Col>

                                                <Col md={8} className='w-100'>
                                                    <Form.Item
                                                        name="Country"
                                                        label="Country"
                                                        className="mb-3 pulse_input"

                                                    >
                                                        <Input className='from-control rounded' placeholder="Enter your country" prefix={<FaGlobe />} />
                                                    </Form.Item>
                                                </Col>

                                                <Col md={24} className="text-center mt-4">
                                                    <Button htmlType='submit' className='btn btn-primary' aria-label="submit">Submit</Button>
                                                </Col>


                                            </Row>
                                        </Form>
                                    </Card>
                                </>
                            }
                        </Col>
                    </Row>
                </div>
            </section>

            <Modal
                open={emailVerifyModal}
                footer={null}
                onCancel={() => setEmailVerifyModal(false)}
                width={400}
                centered
            >
                <div className="email-otp-verify">
                    <Form form={formOtpVerify} onFinish={handleFinishMailVerify}>
                        {!statusMessage ? (
                            <div className="auth otp-page">
                                <h1 className="main-heading my-3">Verify your email</h1>
                                <p className='mb-4'>
                                    Verification email has been sent to{" "}
                                    <Link type="link" onClick={() => setEmailVerifyModal(false)}>
                                        {profileData?.email}
                                        <svg width="1.2em" height="1.2em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fillRule="evenodd" clipRule="evenodd" d="M21.1213 2.70705C19.9497 1.53548 18.0503 1.53547 16.8787 2.70705L15.1989 4.38685L7.29289 12.2928C7.16473 12.421 7.07382 12.5816 7.02986 12.7574L6.02986 16.7574C5.94466 17.0982 6.04451 17.4587 6.29289 17.707C6.54127 17.9554 6.90176 18.0553 7.24254 17.9701L11.2425 16.9701C11.4184 16.9261 11.5789 16.8352 11.7071 16.707L19.5556 8.85857L21.2929 7.12126C22.4645 5.94969 22.4645 4.05019 21.2929 2.87862L21.1213 2.70705ZM18.2929 4.12126C18.6834 3.73074 19.3166 3.73074 19.7071 4.12126L19.8787 4.29283C20.2692 4.68336 20.2692 5.31653 19.8787 5.70705L18.8622 6.72357L17.3068 5.10738L18.2929 4.12126ZM15.8923 6.52185L17.4477 8.13804L10.4888 15.097L8.37437 15.6256L8.90296 13.5112L15.8923 6.52185ZM4 7.99994C4 7.44766 4.44772 6.99994 5 6.99994H10C10.5523 6.99994 11 6.55223 11 5.99994C11 5.44766 10.5523 4.99994 10 4.99994H5C3.34315 4.99994 2 6.34309 2 7.99994V18.9999C2 20.6568 3.34315 21.9999 5 21.9999H16C17.6569 21.9999 19 20.6568 19 18.9999V13.9999C19 13.4477 18.5523 12.9999 18 12.9999C17.4477 12.9999 17 13.4477 17 13.9999V18.9999C17 19.5522 16.5523 19.9999 16 19.9999H5C4.44772 19.9999 4 19.5522 4 18.9999V7.99994Z" fill="#000000"></path> </g></svg>
                                    </Link>
                                    . Please check your inbox.
                                </p>

                                <Form.Item name="otp" rules={[{ required: true, message: "OTP is required" }]}>
                                    <Input.OTP
                                        length={6}
                                        onChange={(value) => setOtp(value)}
                                        placeholder="Enter OTP"
                                    />
                                </Form.Item>
                                <span style={{ color: "red" }}>{invalidMessage}</span>
                                <Form.Item>
                                    <Button className='btn btn-primary py-0 px-4 rounded ms-2' htmlType="submit" loading={loading} aria-label="submit">
                                        Submit
                                    </Button>
                                </Form.Item>
                            </div>
                        ) : (
                            <div className="btn-box py-5 text-center">
                                <img src={done} alt="done" style={{ width: "150px" }} />
                                <h2>{statusMessage}</h2>
                            </div>
                        )}
                    </Form>
                </div>
            </Modal>
        </>
    )
}

export default Profile
